import React from 'react';
import { getTranslation } from '../../../i18n';
import type { SupportedLanguage } from '../../../types';

interface DashboardFooterProps {
  sidebarOpen: boolean;
  language: SupportedLanguage;
}

const DashboardFooter: React.FC<DashboardFooterProps> = ({ sidebarOpen, language }) => {
  const t = (key: string) => getTranslation(language, key);

  return (
    <footer className={`fixed bottom-0 right-0 border-t border-subtle bg-gradient-to-b from-surface-page/95 to-surface-page/98 z-sticky transition-all duration-300 ${sidebarOpen ? 'left-[300px]' : 'left-[60px]'}`}>
      <div className="flex justify-between items-center py-2.5 px-6 text-content-tertiary text-xs">
        <p className="m-0 text-xs font-normal">
          QUAZI © {new Date().getFullYear()} | {t('developedFor')} <a href="https://gsiseguridad.es" target="_blank" rel="noopener noreferrer" className="text-content-tertiary no-underline font-normal transition-colors duration-200 hover:text-primary"><span className="font-bold text-content tracking-wide">GSI</span> Grupo Seguridad Integral</a>
        </p>
        <p className="m-0 text-xs font-normal flex items-center gap-2">
          <span className="fi fi-mx text-base" /> A product of <span className="font-bold text-content tracking-wide">GSI</span> Mexico
        </p>
      </div>
    </footer>
  );
};

export default React.memo(DashboardFooter);
